import { RootState } from "@/store/store";
import { HighchartsChartDataType } from "@/storybook/c8r-highcharts/common/utils/types/common";
import { formatDateByFrequencyType } from "@/utils/helpers/date-time/datetime-format";
import { resourceDetailsCoverageDataPointSelector } from "@/store/resource-details/selectors/coverage-data/options/resourceDetailsCoverageDataPointSelector";
import { commitmentsColors } from "@/utils/constants/commitmentsColors";
import { resourceDetailsResourceCoverageDataSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageDataSelector";

export const resourceDetailsResourceCoverageChartDataSelector = (
  state: RootState,
) => {
  const data = resourceDetailsResourceCoverageDataSelector(state);

  const frequency = resourceDetailsCoverageDataPointSelector(state);

  return data?.granular_data?.reduce(
    (acc, data) => {
      acc.categories.push(formatDateByFrequencyType(frequency, data.date));

      const spData = acc.series?.at(0)?.data;
      const riData = acc.series?.at(1)?.data;
      const onDemandData = acc.series?.at(2)?.data;

      if (spData && data.coverage.savings_plan) {
        spData.push({
          y: data.coverage.savings_plan.percentage ?? null,
          rawValue: data.coverage.savings_plan,
        });
      }

      if (riData && data.coverage.reservation) {
        riData.push({
          y: data.coverage.reservation.percentage ?? null,
          rawValue: data.coverage.reservation,
        });
      }
      if (onDemandData && data.coverage.on_demand) {
        onDemandData.push({
          y: data.coverage.on_demand.percentage ?? null,
          rawValue: data.coverage.on_demand,
        });
      }

      return acc;
    },
    {
      categories: [],
      series: [
        { name: "SP Coverage", data: [], color: commitmentsColors.sp },
        { name: "RI Coverage", data: [], color: commitmentsColors.ri },
        { name: "On-Demand", data: [], color: commitmentsColors.onDemand },
      ],
    } as HighchartsChartDataType,
  );
};
